import { Injectable } from '@angular/core';
import { UserRole } from 'src/app/models/users/users.model';
import { CognitoService } from '../cognito/cognito.service';

@Injectable()
export class RolePermissionService {
    constructor(private cognitoService: CognitoService) { }

    public canActivate(allowedRoles: UserRole[]): boolean {
        // Searching at least one in userGroup
        for (let i = 0; i < allowedRoles.length; i++) {
            if (this.cognitoService.currentUser.groups.includes(allowedRoles[i])) {
                return true;
            }
        }
        return false;
    }

    /**
     * Check if the component should be hidden to the user based on the role
     * @param allowedRoles the roles can access to the component
     * @returns if it should be hidden or not for the user logged
     */
    public isHidden(allowedRoles: UserRole[]): boolean {
        return !this.canActivate(allowedRoles);
    }

    /**
     * Check if component is visible for the current user, based on roles.
     * @param allowedRoles the roles that can access the component, the service checks the user roles for maches
     * @returns true if component is visible for the user role, false otherwise.
     */
    public isComponentVisibleForRole(allowedRoles: UserRole[]): boolean {
        return this.canActivate(allowedRoles);
    }
}
